import "./SellerName.scss"
import ShowDate from "../showDate/ShowDate";
import {useEffect, useState} from "react";
import {ProfileService} from "../../pages/profile/ProfileService";


export default function SellerName() {

    const service = new ProfileService()
    const [message, setMessage] = useState("")
    const [adminFirstName, setAdminFirstName] = useState("");

    useEffect(() => {
        calculateTodayMessage()
        getAdminInfo()
    }, []);

    function calculateTodayMessage() {
        const today = new Date()
        const curHr = today.getHours()

        if (curHr >= 0 && curHr < 6) {
            setMessage("بامداد بخیر ")
        } else if (curHr >= 6 && curHr < 11) {
            setMessage("صبح بخیر ")
        } else if (curHr >= 11 && curHr < 13) {
            setMessage("ظهر بخیر ")
        } else if (curHr >= 13 && curHr < 17) {
            setMessage("عصر بخیر ")
        } else {
            setMessage("شب بخیر ")
        }
    }

    function getAdminInfo() {
        service.getProfileDetail()
            .then(response => {
                setAdminFirstName(response.firstName)
            }).catch(reason => {

        }).finally(_ => {

        })
    }


    return (
        <div className="sellerNameLayout">
            <div className="sellerNameContainer">
                <span className="sellerName">{message}
                    {adminFirstName.length > 0 ?
                        `${adminFirstName} عزیز`
                        : ""
                    }
                </span>
                <span className="sellerNameSubTitle">خلاصه ی آخرین وضعیت سامانه</span>
            </div>
            {/*<ShowDate/>*/}


        </div>
    )
}